import { TIMELINE_TASKS } from './timeline.tasks';
import { TTimelineModel } from './timeline.types';

const log =
  <T1, T2, T3>(msg: string) =>
  (cm: TTimelineModel<T1, T2, T3>) => {
    console.log('[TIMELINE] Timeline Mode', msg, cm);
    return cm;
  };

export const TIMELINE_PIPELINE = {
  sanatize: <T1, T2, T3>(cm: TTimelineModel<T1, T2, T3>): TTimelineModel<T1, T2, T3> => {
    return [
      TIMELINE_TASKS.updateTimelineByPivot,
      TIMELINE_TASKS.updateMonths,
      TIMELINE_TASKS.updateTimeRange,
      TIMELINE_TASKS.updateWeekends,
      TIMELINE_TASKS.udpateEndOfMonths,
      log<T1, T2, T3>('Updated Timeline'),
    ].reduce((a, f) => f(a), cm);
  },
};
